export default "__VITE_ASSET__CpYdO59C__"